// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"476":"ca52db64","631":"c4138e1b","774":"e3ce1de4","787":"1fee1fb8","854":"c68ec817","858":"9f41850a"}[chunkId] + ".chunk.js";
};